import { motion } from 'framer-motion'
import { useLanguage } from '../../../contexts/LanguageContext'
import MobileSlideShell from './MobileSlideShell'
import { fadeScaleProps, M_CARD, M_IMAGE_FRAME } from './mobileMotion'

export default function Slide4M() {
  const { t } = useLanguage()
  const s = t.slides.slide4
  const src = s.image || '/slides/slide_04.png'

  return (
    <MobileSlideShell>
      <motion.h2
        {...fadeScaleProps(0)}
        className="text-[26px] font-semibold leading-tight tracking-tight text-[#1B2A6B]"
      >
        {s.title}
      </motion.h2>

      <motion.div {...fadeScaleProps(0.06)} className={M_IMAGE_FRAME}>
        <img src={src} alt="" className="block w-full" loading="lazy" decoding="async" />
      </motion.div>

      <div className="flex flex-col gap-4">
        {s.steps?.map((step, i) => (
          <motion.div
            key={step.num}
            {...fadeScaleProps(0.1 + i * 0.05)}
            className={M_CARD}
          >
            <div className="mb-2 flex items-center gap-3">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#22A756]/15 text-[15px] font-bold text-[#22A756]">
                {step.num}
              </span>
              <h3 className="text-[17px] font-semibold leading-snug text-[#1B2A6B]">
                {step.title}
              </h3>
            </div>
            <p className="text-[16px] leading-relaxed text-[#1B2A6B]/65">{step.body}</p>
          </motion.div>
        ))}
      </div>
    </MobileSlideShell>
  )
}
